<template>
  <div class="row income-footer">
  <b-container>
    <b-row align-content="stretch" v-show="showmenu" class="justify-content-between income-footer-nav">
      <b-col sm="12" md="4" class="income-footer-group">

        <b-row class="income-footer-title">{{ $t('footer.contactUs') }}</b-row>

        <b-col class="income-footer-col" md="12">{{ $t('footer.incomeCompanyO') }}</b-col>
        <b-col class="income-footer-col" md="12">{{ $t('footer.officeHoursAm') }}</b-col>
        <b-col class="income-footer-col" md="12">
          <img class="country-flag" :src="getFlag('eu')">
          <a href="callto:+441164649956">{{ $t('footer.3681') }}</a>
        </b-col>
        <b-col class="income-footer-col income-footer-col-50" md="12" sm="5">
          <img class="country-flag" :src="getFlag('ee')">
          <a href="tel:+3726600353">{{ $t('footer.2998') }}</a>
        </b-col>
        <b-col class="income-footer-col" md="12"><a href="mailto:hello@getincome.com">{{ $t('footer.hellogetincomecom') }}</a></b-col>
      </b-col>

      <b-col sm="12" md="2" class="income-footer-group">
        <b-row class="income-footer-title">{{ $t('footer.aboutUs') }}</b-row>

        <b-col class="income-footer-col income-footer-col-50" sm="6" md="12">
          <a :href="'/' + $t('router.wpLinks.howItWorks')">{{ $t('footer.howItWorks') }}</a>
        </b-col>
        <b-col class="income-footer-col income-footer-col-50" sm="6" md="12">
          <router-link :to="'/' + $t('router.links.security')" @click.native="scrollToTop">{{ $t('footer.security') }}</router-link>
        </b-col>
        <b-col class="income-footer-col income-footer-col-50" sm="6" md="12">
          <router-link :to="'/' + $t('router.links.risk')" @click.native="scrollToTop">{{ $t('footer.risks') }}</router-link>
        </b-col>
        <b-col class="income-footer-col income-footer-col-50" sm="6" md="12">
          <a :href="'/' + $t('router.wpLinks.securityFeatures')">{{ $t('footer.securityFeatures') }}</a>
        </b-col>
        <b-col class="income-footer-col income-footer-col-50" sm="6" md="12" v-if="this.$auth.isAuthenticated">
          <a href="/blog/">{{ $t('navbar.blog') }}</a>
        </b-col>
      </b-col>

      <b-col sm="12" md="2" class="income-footer-group">
        <b-row class="income-footer-title">{{ $t('footer.company') }}</b-row>

        <b-col class="income-footer-col income-footer-col-50" sm="6" md="12">
          <a :href="'/' + $t('router.wpLinks.team')">{{ $t('footer.team') }}</a>
        </b-col>
        <b-col class="income-footer-col income-footer-col-50" sm="6" md="12">
          <a :href="'/' + $t('router.wpLinks.help')">{{ $t('footer.faq') }}</a>
        </b-col>
        <b-col class="income-footer-col income-footer-col-50" sm="6" md="12" v-if="this.$auth.isAuthenticated">
          <router-link :to="'/' + $t('router.links.statistics')" @click.native="scrollToTop">{{ $t('footer.statistics') }}</router-link>
        </b-col>
        <b-col class="income-footer-col income-footer-col-50" sm="6" md="12">
          <router-link :to="'/' + $t('router.links.affiliate')" @click.native="scrollToTop">{{ $t('footer.affiliate') }}</router-link>
        </b-col>
        <b-col class="income-footer-col income-footer-col-50" sm="6" md="12">
          <router-link :to="'/' + $t('router.links.joinLoanOriginators')" @click.native="scrollToTop">{{ $t('footer.joinAsLo') }}</router-link>
        </b-col>
        <b-col class="income-footer-col income-footer-col-50" sm="6" md="12">
          <router-link :to="'/' + $t('router.links.invite')" target="_blank">{{ $t('footer.inviteAFriend') }}</router-link>
        </b-col>
        <b-col class="income-footer-col income-footer-col-50" sm="6" md="12">
          <a href="/blog/annual-reports/" target="_blank">{{ $t('footer.annualReports') }}</a>
        </b-col>
      </b-col>

      <b-col sm="12" md="2" class="income-footer-group income-footer-group-connect">
        <b-row class="income-footer-title">{{ $t('footer.social') }}</b-row>

        <b-col class="income-footer-col income-footer-col-33">
          <a target="_blank" href="https://www.linkedin.com/company/income-marketplace/">
            <img class="social-icon" v-bind:src="getSrc('social/linkedin.svg')" alt="">{{ $t('footer.linkedin') }}
          </a>
        </b-col>
        <b-col class="income-footer-col income-footer-col-33">
          <a target="_blank" href="https://www.facebook.com/IncomeMarketplace/">
            <img class="social-icon" v-bind:src="getSrc('social/facebook.svg')" alt="">{{ $t('footer.facebook') }}
          </a>
        </b-col>
        <b-col class="income-footer-col income-footer-col-33">
          <a target="_blank" href="https://www.youtube.com/channel/UCnMcn1QXpSiPVfMz1gZObcA/">
            <img class="social-icon" v-bind:src="getSrc('social/youtube-logo.svg')" alt="">{{ $t('footer.youtube') }}
          </a>
        </b-col>
        <b-col class="income-footer-col income-footer-col-33">
          <a target="_blank" href="https://www.instagram.com/incomemarketplace/?hl=en">
            <img class="social-icon" v-bind:src="getSrc('social/instagram.svg')" alt="">{{ $t('footer.instagram') }}</a>
        </b-col>
        <b-col class="income-footer-col income-footer-col-33">
          <a target="_blank" href="https://t.me/income_marketplace_chat">
            <img class="social-icon" v-bind:src="getSrc('social/telegram-app.svg')" alt="">{{ $t('footer.telegram') }}</a>
        </b-col>
      </b-col>

<!--      <b-col sm="12" md="2" class="income-footer-group">-->
<!--        <b-row class="income-footer-title">{{ $t('footer.downloadApp') }}</b-row>-->
<!--        <b-col class="income-footer-col income-footer-col-33">-->
<!--          <a target="_blank" href="https://apps.apple.com/us/app/income-marketplace/id1569183737 ">-->
<!--            <img class="downapp" v-bind:src="getSrc('app/appstore.png')" alt="">-->
<!--          </a>-->
<!--        </b-col>-->
<!--        <b-col class="income-footer-col income-footer-col-33">-->
<!--          <a target="_blank" href="https://play.google.com/store/apps/details?id=com.income.app">-->
<!--            <img class="downapp" v-bind:src="getSrc('app/googleplay.png')" alt="">-->
<!--          </a>-->
<!--        </b-col>-->
<!--      </b-col>-->
    </b-row>
    <b-row class="income-footer-copyright">

      <b-col md="3" sm="12">{{ $t('footer.incomeCompany') }}</b-col>
      <b-col class="income-footer-col-33" md="2" sm="3">
        <router-link :to="'/' + $t('router.links.useragreement')" @click.native="scrollToTop" class="de-break-word">{{ $t('footer.userAgreement') }}</router-link>
      </b-col>
      <b-col class="income-footer-col-33" md="2" sm="3">
        <router-link :to="'/' + $t('router.links.privacy')" @click.native="scrollToTop" class="de-break-word">{{ $t('footer.privacyPolicy') }}</router-link>
      </b-col>
      <b-col class="income-footer-col-33" md="2" sm="3">
        <router-link to="/cookie" @click.native="scrollToTop">{{ $t('footer.cookiePolicy') }}</router-link>
      </b-col>
      <b-col class="income-footer-col-33" md="2" sm="3">
        <language-switcher></language-switcher>
      </b-col>
    </b-row>

    <!-- TODO Should be hide on prod! -->
<!--    <b-row>-->
<!--      <div class="lemonway-section">-->
<!--        <img v-bind:src="getSrc('lemon_way_logo.png')" alt="Lemon Way">-->
<!--        <p>Partner of <a href="https://www.lemonway.com/" target="_blank">Lemon Way</a>, a European payment institution accredited in France by the ACPR (CIB 16568). <a href="https://www.lemonway.com/en/terms-and-conditions/" target="_blank" class="lemonway-tc">Terms and conditions</a></p>-->
<!--      </div>-->
<!--    </b-row>-->

    <b-row class="income-footer-description">
      <p>{{ $t('footer.incomeCompanyO1') }}</p>
      <p>{{ $t('footer.allInvestmentsInvolve') }}</p>
    </b-row>

  </b-container>

  </div>
</template>

<script>
import flagMixin from '../mixins/flag'
import imageMixin from '../mixins/image'
import LanguageSwitcher from '@/components/LanguageSwitcher'

export default {
  name: 'Footer',
  components: {LanguageSwitcher},
  props: ['showmenu'],
  methods: {
    scrollToTop()
    {
      window.scrollTo(0, 0)
    }
  },
  mixins: [flagMixin, imageMixin]
}
</script>

<style lang="scss" scoped>
footer {
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 18px;
  color: #9DA0A6;
}

.footer-menus {
  margin-top: 63px;

  .footer-title {
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 24px;
    color: #30A7FE;
    margin-bottom: 16px;
  }

  .footer-widget {
    a {
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      line-height: 24px;
      color: #000000;
    }

    .list-unstyled li {
      margin-bottom: 16px;
    }
  }
}

.privacy-menu {
  margin-top: 25px;
  text-align: center;
  font-size: 16px;
  line-height: 24px;
  color: #6E777A;

  a {
    color: #6E777A;
  }

  .list-inline-item:not(:last-child) {
    margin-right: 2.0rem;
  }
}

.phone-number {
  display: flex;
  align-items: center;
}

.country-flag {
  display: inline-block;
  margin-right: 10px;
  background-size: cover;
  background-position: center;
  border-radius: 50%;
  width: 20px;
  height: 20px;
}

.lemonway-section {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: wrap;
  margin-top: 48px;

  img {
    width: 200px;
    height: auto;
  }

  p {
    flex: 0 0 100%;
    margin-top: 8px;
    color: #6E777A;
  }

  .lemonway-tc {
    display: block;
  }
}

.social-icon {
  max-width: 30px;
  max-height: 30px;
  padding: 5px 5px 5px 2px;
}

.downapp {
  max-width: 171px;
  margin-bottom: 7px;
}

@media only screen and (min-width: 992px) {
  .lemonway-section {
    p {
      flex: 1 1 600px;
      margin-top: 0;
      margin-left: 16px;
    }

    .lemonway-tc {
      display: inline;
    }
  }
}

@media only screen and (min-width: 1200px) {
  .lemonway-section {
    .lemonway-tc {
      display: block;
    }
  }
}

</style>
